import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import moment from 'moment-jalaali';
import { BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle } from "bootstrap-vue";

export default {
  name: "HavaleBarcodeCreate",
  components: {
    FormModal,
    Loading,
    BTooltip, BButton, BCollapse, BCard, BFormGroup, BFormInput, BTable,
    ProductSearch,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      productSelect: null,
      stores: [],
      sellers: [],
      productSku: "",
      varietySelect: null,
      balanceProductSku: "",
      destinationAgency: null,
      toStore: null,
      seller: null,
      fromStore: null,
      isButtonDisabled: false,
      varieties: [],
    }
  },
  // computed: {
  // agencies() {
  // return this.$store.getters["admin/stores"];
  // },
  // },
  mounted() {
    this.loadStores();
    this.loadSellers();
  },
   watch: {
  },
  methods: {
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            sku: this.productSku,
            refund: 0,
          },
        });
        const variety = response.data.data.variety;
        this.balanceProductSku = response.data.data.balances;
        console.log(this.balanceProductSku,'this.balanceProductSku');
        
        const exists = this.varieties.find(item => item.id === variety.id);
        
        if (exists) {
          exists.quantity_havale += 1;
        }else{
          variety.quantity_havale = 1;
          this.varieties.push({
            ...variety,
            created_at: moment().format('jYYYY/jM/jD ساعت HH:mm:ss'),
            product_title: variety.product.title,
            from_store_name: this.fromStore.name,
            to_store_name: this.toStore.name,
          });
        }
        this.productSku = null;
        this.productSku = "";
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {  
            this.$refs.productSku.focus();  
        });  
      }
    },
    async loadStores(){
      try {
          const response = await this.$axios.get("admin/stores");
          this.stores = response.data.data.stores;
      } catch (e) {
          this.$root.notify(e);
      } 
    },  
    async loadSellers(){
      try {
          const response = await this.$axios.get("admin/sellers?all=1&active=1");
          this.sellers = response.data.data.sellers;
      } catch (e) {
          this.$root.notify(e);
      } 
    },  
    // selectedVariety(item) {
    //   this.varietySelect = item;
    // },
    // selectTheProduct(item) {
    //   this.productSelect = item;
    // },
    // addVariety() {
    //   if (this.varietySelect) {
    //     const exists = this.varieties.some(variety => variety.id === this.varietySelect.id);
    //     if (exists) {
    //       this.$root.notify(
    //         "این تنوع تکراری است.",
    //         "warning"
    //       );
    //       return;
    //     }
    //     this.varieties.push({
    //       ...this.varietySelect,
    //       created_at: moment().format('jYYYY/jM/jD ساعت HH:mm:ss'),
    //       product_title: this.productSelect.title,
    //       from_store_name: this.fromStore.name,
    //       to_store_name: this.toStore.name,
    //     });
    //     this.varietySelect = null;
    //     $('#add-variety-modal').modal('hide');
    //   } else {
    //     if (this.productSelect) {
    //       const newVarieties = this.productSelect.varieties.map(item => ({
    //         ...item,
    //         created_at: moment().format('jYYYY/jM/jD ساعت HH:mm:ss'),
    //         product_title: this.productSelect.title,
    //         from_store_name: this.fromStore.name,
    //         to_store_name: this.toStore.name,
    //       }));
    //       newVarieties.forEach(variety => {
    //         const balanceItem = variety.store_items.find(item => item.store_id == this.fromStore.id);
    //         variety.store_balance = balanceItem ? balanceItem.balance : 0;
    //       });
    //       const filteredVarieties = newVarieties.filter(variety => variety.store_balance != 0);
    //       this.varieties.push(...filteredVarieties);
    //       this.varietySelect = null;
    //       $('#add-variety-modal').modal('hide');
    //     }
    //   }
    // },
    deleteVariety(index) {
      this.varieties.splice(index, 1);
    },
    async submitData() {
      const selectedFromStore = this.fromStore;
      const selectedToStore = this.toStore;
      const data = {
        from_store_id: selectedFromStore.id,
        to_store_id: selectedToStore.id,
        transmitter_id: this.seller ? this.seller.id : '',
        varieties: this.varieties.map(variety => ({
          id: variety.id,
          quantity: variety.quantity_havale,
        }))
      };
      try {
        const response = await this.$axios.post('admin/stores/remittance', data);
        this.$root.notify(response.data.message, 'success');
        this.isButtonDisabled = true;  
        location.reload();
      } catch (error) {  
        this.$root.notify(error)
      }
    }
  }
}

